import { useTranslate } from 'hooks/useTranslate';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import { State } from 'redux/initialState';
import hasPlanCustomDilution, {
  getPartnersNamesWithCustomDilution,
} from 'utils/customDilution';
import { hasPartnersDecoupled } from 'utils/showDetails';

const DilutionBadge: FC = () => {
  const { t } = useTranslate();
  const plans = useSelector((state: State) => state.plans);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const partners = useSelector((state: State) => state.partners);

  const [showBadge, setShowBadge] = useState<boolean>(false);
  const [partnersList, setPartnersList] = useState<string[]>([]);

  useEffect(() => {
    if (plans?.length) {
      setShowBadge(hasPlanCustomDilution(plans));
    }
  }, [plans]);

  useEffect(() => {
    const currentPartners = hasPartnersDecoupled()
      ? partners
      : actualSociety?.partners;

    if (showBadge && currentPartners?.length) {
      setPartnersList(getPartnersNamesWithCustomDilution(currentPartners));
    }
  }, [showBadge, actualSociety?.partners, partners]);

  return (
    showBadge && (
      <>
        <span
          className="badge badge-dim badge-danger"
          data-tooltip-id="dilution-tooltip"
          style={{ marginRight: '36px', marginTop: '3px' }}
        >
          {t('DilutionInfo')}
        </span>

        <Tooltip id="dilution-tooltip" place="top">
          <div className="fw-normal">
            {t('DilutionInfoMessage')}
            <br />

            <ul className="list text-left">
              {partnersList?.map((partnerName: string) => (
                <li key={partnerName}>{partnerName}</li>
              ))}
            </ul>
          </div>
        </Tooltip>
      </>
    )
  );
};

export default DilutionBadge;
